import { createPatientIdFields, createDate } from "./proxy";
import repeatPrescriptionForm from "./formidable/prescription";
//
const removeField = (el) => {
  el.remove();
};

const visuallyHideField = (el) => {
  el.className = "nhsuk-u-visually-hidden";
};

const addAutocomplete = (el) => {
  const input = el.querySelector("input");
  const textarea = el.querySelector("textarea");

  let autocomplete = "off";

  if (el.classList.contains("sp_emailchecker")) {
    autocomplete = "email";
  }
  if (el.classList.contains("sp_postcodechecker")) {
    autocomplete = "postal-code";
  }
  if (el.classList.contains("sp_phonechecker")) {
    autocomplete = "tel-national";
  }
  if (el.classList.contains("sp_address")) {
    autocomplete = "on";
  }
  if (input) {
    input.setAttribute("autocomplete", autocomplete);
  }
  if (textarea) {
    textarea.setAttribute("autocomplete", autocomplete);
  }
};

const addressField = (el) => {
  let legend = el.querySelector("legend");
  let primaryLabel = el.querySelector(".frm_primary_label");
  let fieldset = el.querySelector("fieldset");
  let autocomplete = true;

  if (el.classList.contains("autocomplete_off")) {
    autocomplete = false;
  }
  if (legend) {
    legend.classList = "nhsuk-fieldset__legend nhsuk-fieldset__legend--s";
    legend.innerHTML = primaryLabel.innerHTML;
  }
  if (primaryLabel) {
    primaryLabel.remove();
  }
  if (fieldset) {
    fieldset.classList = "nhsuk-fieldset";
    fieldset.removeAttribute("aria-labelledby");
  }
  // Loop through address fields
  el.querySelectorAll(".frm_form_field ").forEach((e) => {
    let label = e.querySelector("label");
    let input = e.querySelector("input");
    let hint = e.querySelector(".frm_description");
    // Remove duplicate hint
    if (hint) {
      hint.remove();
    }
    if (!autocomplete) {
      input.setAttribute("autocomplete", "off");
    }
    switch (true) {
      case e.classList.contains("line1"):
        label.classList = "nhsuk-label";
        break;
      case e.classList.contains("line2"):
        label.classList = "nhsuk-u-visually-hidden";
        break;
      case e.classList.contains("city"):
        label.classList = "nhsuk-label";
        input.classList = "nhsuk-input--width-20";
        break;
      case e.classList.contains("zip"):
        label.classList = "nhsuk-label";
        input.classList = "nhsuk-input--width-10";
        break;
      default:
        break;
    }
  });
};

const addDOBField = (el, autocomplete = "bday") => {
  let label = el.querySelector("label");
  let input = el.querySelector("input");
  let isRequired = el.classList.contains("frm_required_field");

  if (isRequired) {
    // Remove the asterisk
    label.removeChild(label.firstElementChild);
  }

  el.innerHTML = "";

  el.append(
    createDate({
      id: input.id,
      name: input.name,
      label: label.textContent,
      className: "nhsuk-fieldset__legend--s",
      hint: "For example, 31 3 1980",
      autocomplete,
      required: isRequired,
      value: input.value,
    })
  );
};

const addDateField = (el) => {
  addDOBField(el, "off");
};

// classname and callback
const classRegister = {
  frm_invisible_section: visuallyHideField,
  frm_meds: repeatPrescriptionForm,
  frm_meds_4: repeatPrescriptionForm,
  scorelessthan20: removeField,
  score20to24: removeField,
  score25: removeField,
  nextquestions: removeField,
  medtitle: removeField,
  importantsignpost: removeField,
  scorehide: removeField,
  totalscore: removeField,
  smallinline: removeField,
  scorelessthan5: removeField,
  scoremorethan5: removeField,
  sp_dobchecker: addDOBField,
  sp_date: addDateField,
  sp_emailchecker: addAutocomplete,
  sp_postcodechecker: addAutocomplete,
  sp_phonechecker: addAutocomplete,
  sp_address: addressField,
};

const backLink = () => {
  const link = document.createElement("div");

  link.classList.add("nhsuk-back-link");

  link.innerHTML = `<a class="nhsuk-back-link__link frm_prev_page" href="#">
                      <svg class="nhsuk-icon nhsuk-icon__chevron-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" height="24" width="24">
                        <path d="M8.5 12c0-.3.1-.5.3-.7l5-5c.4-.4 1-.4 1.4 0s.4 1 0 1.4L10.9 12l4.3 4.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-5-5c-.2-.2-.3-.4-.3-.7z"></path>
                      </svg>
                      Back
                    </a>`;
  return link;
};

const button = (el) => {
  // Add back link
  if (el.classList.contains("frm_prev_page")) {
    el.remove();
    document.querySelector(".frm_fields_container").prepend(backLink());
    return;
  }
  // Main submit
  if (
    el.classList.contains("frm_button_submit") ||
    el.classList.contains("frm_final_submit")
  ) {
    el.className = "nhsuk-button";
  }
};

const fieldset = (label) => {
  const fieldset = document.createElement("fieldset");
  const legend = document.createElement("legend");

  legend.classList.add("nhsuk-fieldset__legend", "nhsuk-fieldset__legend--s");

  legend.append(label);

  fieldset.classList.add("nhsuk-fieldset");

  fieldset.appendChild(legend);

  return fieldset;
};

const checkbox = (el) => {
  let checkboxes = el.querySelector(".frm_opt_container");
  checkboxes.classList.add("nhsuk-checkboxes");

  for (const checkbox of el.querySelectorAll(".frm_checkbox")) {
    const label = checkbox.querySelector("label");
    const input = checkbox.querySelector("input");
    checkbox.className = "nhsuk-checkboxes__item";
    input.className = "nhsuk-checkboxes__input";
    label.className = "nhsuk-label nhsuk-checkboxes__label";
    label.before(input);
  }
  const legend = el.querySelector(".frm_primary_label");

  if (legend) el.prepend(fieldset(legend));

  el.querySelector(".nhsuk-fieldset").append(checkboxes);
};

const otherField = (el) => {
  // Other field wrapper
  const formGroup = Object.assign(document.createElement("div"), {
    className: "nhsuk-form-group nhsuk-u-margin-top-3",
  });
  const otherLabel = el.querySelector("label.frm_screen_reader");
  if (otherLabel) {
    formGroup.appendChild(otherLabel);
  }
  const otherInput = el.querySelector(".frm_other_input");
  otherInput.classList.add("nhsuk-input", "nhsuk-u-visually-hidden");
  otherInput.placeholder = "Please specify...";
  formGroup.appendChild(otherInput);
  // add callback
  el.append(formGroup);
  for (const input of el.querySelectorAll("input")) {
    input.addEventListener("change", (e) => {
      if (e.target.value === "Other") {
        otherInput.classList.remove("nhsuk-u-visually-hidden");
      } else {
        otherInput.classList.add("nhsuk-u-visually-hidden");
      }
    });
  }
  return;
};

const radio = (el) => {
  const legend = el.querySelector(".frm_primary_label");
  // Requires tidy up
  if (legend) {
    el.prepend(
      fieldset(
        Object.assign(document.createElement("div"), {
          className: legend.classList,
          innerHTML: legend.innerHTML,
        })
      )
    );
    legend.remove();
  }

  let radios = el.querySelector(".frm_opt_container");

  if (!radios) {
    radios = Object.assign(document.createElement("div"), {
      className: "frm_opt_container",
    });
  }

  radios.setAttribute("role", "radiogroup");
  radios.classList.add("nhsuk-radios");

  if (el.classList.contains("frm_required_field")) {
    radios.setAttribute("aria-required", "true");
  }

  if (radios.hasAttribute("aria-labelledby")) {
    radios.removeAttribute("aria-labelledby");
  }

  if (el.classList.contains("horizontal_radio")) {
    //el.querySelector(".nhsuk-radios").classList.add("nhsuk-radios--inline");
  }

  for (const radio of el.querySelectorAll(".frm_radio, .frm_scale")) {
    const label = radio.querySelector("label");
    const input = radio.querySelector("input");

    radio.className = "frm_radio nhsuk-radios__item";
    input.className = "nhsuk-radios__input";
    label.className = "nhsuk-label nhsuk-radios__label";

    input.removeAttribute("aria-required");

    label.before(input);
    // If other render the text field and hide label nhsuk-u-visually-hidden
    radios.append(radio);
  }

  el.querySelector(".nhsuk-fieldset").append(radios);
};

const select = (el) => {
  const label = el.querySelector("label");
  const select = el.querySelector("select");
  label.classList.add(
    "nhsuk-label",
    "nhsuk-label--s",
    "nhsuk-u-margin-bottom-3"
  );
  select.classList.add("nhsuk-select");
  if (!select.hasAttribute("autocomplete")) {
    select.setAttribute("autocomplete", "off");
  }
};

const text = (el) => {
  let label = el.querySelector("label");
  let input = el.querySelector("input");
  input.classList.add("nhsuk-input");
  if (!label.classList.contains("nhsuk-label")) {
    label.classList.add(
      "nhsuk-label",
      "nhsuk-label--s",
      "nhsuk-u-margin-bottom-3"
    );
  }
  if (!input.hasAttribute("autocomplete")) {
    input.setAttribute("autocomplete", "off");
  }
};

const textarea = (el) => {
  let label = el.querySelector("label");
  let textarea = el.querySelector("textarea");
  label.classList.add(
    "nhsuk-label",
    "nhsuk-label--s",
    "nhsuk-u-margin-bottom-3"
  );
  textarea.classList.add("nhsuk-textarea");
  if (!textarea.hasAttribute("autocomplete")) {
    textarea.setAttribute("autocomplete", "off");
  }
};

const hint = (el) => {
  const description = el.querySelector(".frm_description");
  const legend = el.querySelector("legend");
  const label = el.querySelector("label");
  if (!description) {
    return;
  }
  description.className = "nhsuk-hint";
  if (legend) {
    legend.after(description);
    return;
  }
  if (label) {
    label.after(description);
  }
};

// hidden verified field
const verified = () => {
  const input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", "verified");
  input.setAttribute("value", "OK");
  return input;
};

const previewAnswer = () => {
  const input = document.createElement("input");
  input.setAttribute("id", "previewAnswer");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", "preview_answer");
  return input;
};

const errorSummary = (el) => {
  el.innerHTML = "";
  el.classList.add("nhsuk-error-summary");

  el.setAttribute("role", "alert");

  const heading = Object.assign(document.createElement("h2"), {
    className: "nhsuk-error-summary__title",
    innerHTML: "There is a problem",
  });

  const body = Object.assign(document.createElement("div"), {
    className: "nhsuk-error-message",
    innerHTML: "Errors are marked",
  });
  el.append(heading, body);
};

const errorField = () => {
  console.log();
};

const loader = () => {
  let wrapper = Object.assign(document.createElement("div"), {
    className: "loader-wrapper",
    id: "loader",
  });
  wrapper.append(
    Object.assign(document.createElement("div"), {
      className: "loader",
    })
  );
  return wrapper;
};

const renderForm = (test) => {
  const form = document.querySelector(".frm-show-form");

  if (!form) {
    return;
  }

  // Remove hidden class
  form.classList.remove("nhsuk-u-visually-hidden");

  form.appendChild(verified());

  // Add class to form wrapper
  document.querySelector("fieldset").classList.add("nhsuk-fieldset");

  // Hide the form legend
  const formTitle = document.querySelector(".frm_screen_reader");

  if (formTitle) {
    formTitle.classList.add("nhsuk-u-visually-hidden");
    formTitle.after(
      Object.assign(document.createElement("div"), {
        className: "nhsuk-hint",
        innerHTML: "Required fields are labelled",
      })
      // Object.assign(document.createElement("div"), {
      //   id: "age-hint",
      //   className: "nhsuk-hint",
      //   innerHTML: "You must be aged 13 or over to complete this form yourself",
      // })
    );
  }

  // Append the required fields message

  // Hide the Formidable anit spam field
  const honeyTrap = document.querySelector(".frm_verify");
  if (honeyTrap) {
    honeyTrap.classList.add("nhsuk-u-visually-hidden");
    honeyTrap.previousElementSibling.classList.add("nhsuk-u-visually-hidden");
  }

  // Collect fields
  const fields = document.querySelectorAll(".frm_form_field");

  // Preview Answer
  const previewField = document.querySelector(".preview_answer");
  if (previewField) {
    previewField.appendChild(previewAnswer());
    previewField.onchange = (e) => {
      document.getElementById("previewAnswer").value = e.target.value;
    };
  }

  // Loop through input fields
  for (const element of fields) {
    // Loop through class register
    for (const registeredClass of Object.keys(classRegister)) {
      if (element.classList.contains(registeredClass)) {
        // use callback
        classRegister[registeredClass](element);
      }
    }

    if (element.classList.contains("sp_address")) {
      //return;
    }

    const alcohols1 = element.querySelector(".alcohols1");

    if (alcohols1) {
      alcohols1.remove();
    }
    const alcohols2 = element.querySelector(".alcohols2");
    if (alcohols2) {
      alcohols2.remove();
    }

    if (
      element.classList &&
      element.classList.contains("frm_section_heading")
    ) {
      continue;
    }

    element.classList.add("nhsuk-form-group");

    const fieldType = element.querySelector("input");
    if (fieldType) {
      switch (fieldType.type) {
        case "checkbox":
          checkbox(element);
          break;
        case "text":
        case "email":
        case "number":
        case "tel":
          text(element);
          break;
        case "radio":
          radio(element);
          break;
        case "button":
        case "submit":
          button(element);
          break;
        default:
        // code block
      }
    }
    // Select
    if (element.querySelector("select")) {
      select(element);
    }

    // Textarea
    if (element.querySelector("textarea")) {
      textarea(element);
    }

    // Hint
    hint(element);

    const inlineStyle = element.querySelector("style");
    // Remove all inline styles
    if (inlineStyle) {
      element.querySelector("style");
      inlineStyle.remove();
    }

    //frm_other_container
    if (element.classList.contains("frm_other_container")) {
      otherField(element);
    }

    // Error callback
    const errorCallback = (mutationList, observer) => {
      const summary = document.querySelector(".frm_error_style");
      const error = element.querySelector(".frm_error");
      const input = element.querySelectorAll("input");

      if (summary) {
        errorSummary(summary);
      }

      if (error) {
        element.classList.add("nhsuk-form-group--error");
        error.classList.add("nhsuk-error-message", "nhsuk-u-margin-top-2");
        if (input) {
          input.forEach((i) => {
            i.classList.add("nhsuk-input--error");
          });
        }
        if (element.classList.contains("line1")) {
          error.innerHTML = "Enter the building and street";
          input.setAttribute("aria-describedby", error.id);
        }
        if (element.classList.contains("city")) {
          error.innerHTML = "Enter a town or city";
          input.setAttribute("aria-describedby", error.id);
        }
        if (element.classList.contains("zip")) {
          error.innerHTML = "Enter a UK postcode";
          input.setAttribute("aria-describedby", error.id);
        }
        // Look for address generic error field
        if (element.querySelector(".sp_address > .frm_error")) {
          element.querySelector(".sp_address > .frm_error").innerHTML = "";
        }
        return;
      }
      element.classList.remove("nhsuk-form-group--error");
      if (input) {
        input.forEach((i) => {
          i.classList.remove("nhsuk-input--error");
        });
      }
    };

    // Validation listener
    const observer = new MutationObserver(errorCallback);
    observer.observe(element, { childList: true });
  }

  // Replace section headings
  const headings = document.querySelectorAll(".frm_section_heading > h3");
  for (const heading of headings) {
    let newHeading = Object.assign(document.createElement("h2"), {
      //className: "nhsuk-fieldset__legend--s",
      innerHTML: heading.innerHTML,
    });
    heading.replaceWith(newHeading);
  }
  // Add visually hidden to hidden section heading
  const hiddenSections = document.querySelectorAll(".frm_hide_section > h2");
  for (const hiddenSection of hiddenSections) {
    hiddenSection.className = "nhsuk-u-visually-hidden";
  }

  // Replace section descriptions
  const sectionDescriptions = document.querySelectorAll(
    ".frm_description, .frm_section_spacing"
  );

  for (const sectionDescription of sectionDescriptions) {
    sectionDescription.classList.add("nhsuk-hint");
  }

  // Buttons
  const buttons = document.querySelectorAll("button, .frm_prev_page");

  // Preview answer
  for (const element of buttons) {
    button(element);
  }

  // Submit buttons
  const submitButtons = document.querySelectorAll(
    ".frm_forms input[type=submit]"
  );

  for (const submit of submitButtons) {
    submit.className = "nhsuk-button";
  }

  // Remove ajax loader image
  const ajaxLoader = document.getElementsByClassName("frm_ajax_loading");
  if (ajaxLoader && ajaxLoader.length > 0) {
    ajaxLoader[0].remove();
  }

  createPatientIdFields();

  // frm_required_field
  document.querySelectorAll(".frm_required").forEach((span) => {
    if (span.innerHTML.length > 0) {
      span.classList.add("nhsuk-tag", "nhsuk-tag--grey");
      span.innerHTML = "Required";
    }
  });

   const frm_fields = document.querySelectorAll
      ? document.querySelectorAll(".frm_form_field")
      : [];

    frm_fields.forEach(el => {
      // Skip already-processed fields
      if (el.dataset.nhsukProcessed === "1") return;

      // Mark as processed early to avoid double-processing
      el.dataset.nhsukProcessed = "1";

      // -- TEXT/INPUT LABELS --
      const label = el.querySelector("label");
      if (label) {
        // helper to wrap label in <h1> with wrapper class if not already wrapped
        function wrapLabelAsH1() {
          const parent = label.parentElement;
          if (!parent || parent.classList.contains("nhsuk-label-wrapper")) return;
          const wrapper = document.createElement("h1");
          wrapper.classList.add("nhsuk-label-wrapper");
          parent.insertBefore(wrapper, label);
          wrapper.appendChild(label);
        }

        if (el.classList.contains("h1_label_l")) {
          wrapLabelAsH1();
          label.classList.remove("nhsuk-label--s");
          label.classList.add("nhsuk-label--l");
        }

        if (el.classList.contains("h1_label_xl")) {
          wrapLabelAsH1();
          label.classList.remove("nhsuk-label--s");
          label.classList.add("nhsuk-label--xl");
        }
      }

      // -- SECTION fields --
      if (
        el.classList.contains("h1_section_l") ||
        el.classList.contains("h1_section_xl") ||
        el.classList.contains("h2_section_m")
      ) {
        // prefer existing heading elements; fallback to block elements
        let heading = el.querySelector("h2, legend, div, span, p");

        if (!heading) {
          const text = el.textContent.trim();
          if (text) {
            heading = document.createElement("h2");
            heading.textContent = text;
            el.innerHTML = "";
            el.prepend(heading);
          }
        }

        if (heading) {
          if (el.classList.contains("h1_section_l")) {
            const h1 = document.createElement("h1");
            h1.innerHTML = heading.innerHTML;
            h1.className = "nhsuk-label nhsuk-label--l";
            heading.replaceWith(h1);
          } else if (el.classList.contains("h1_section_xl")) {
            const h1 = document.createElement("h1");
            h1.innerHTML = heading.innerHTML;
            h1.className = "nhsuk-label nhsuk-label--xl";
            heading.replaceWith(h1);
          } else if (el.classList.contains("h2_section_m")) {
            if (heading.tagName.toLowerCase() !== "h2") {
              const h2 = document.createElement("h2");
              h2.innerHTML = heading.innerHTML || heading.textContent;
              heading.replaceWith(h2);
              heading = h2;
            }
            heading.classList.add("nhsuk-label", "nhsuk-label--m");
          }
        } else {
          // optional: console.warn("No heading found for section", el);
        }
      }

      // -- LEGEND fields --
      if (el.classList.contains("h1_legend_l") || el.classList.contains("h1_legend_xl")) {
        const fieldset = el.querySelector("fieldset");
        const legend = fieldset ? fieldset.querySelector("legend") : null;

        if (legend && !legend.dataset.nhsukLegendProcessed) {
          // protect against multiple processing of same legend
          legend.dataset.nhsukLegendProcessed = "1";

          const h1 = document.createElement("h1");
          h1.classList.add("nhsuk-fieldset__heading");

          // move existing children into the new h1
          while (legend.firstChild) {
            h1.appendChild(legend.firstChild);
          }
          legend.appendChild(h1);

          // normalise legend size classes
          legend.classList.remove(
            "nhsuk-fieldset__legend--s",
            "nhsuk-fieldset__legend--m",
            "nhsuk-fieldset__legend--l",
            "nhsuk-fieldset__legend--xl"
          );

          if (el.classList.contains("h1_legend_l")) {
            legend.classList.add("nhsuk-fieldset__legend--l");
          } else if (el.classList.contains("h1_legend_xl")) {
            legend.classList.add("nhsuk-fieldset__legend--xl");
          }
        }
      }
    });
};

jQuery(document).on("frmPageChanged", () => {
  renderForm();
});

jQuery(document).on("frmFormComplete", () => {
  renderForm();
});

jQuery(document).ready(() => {
  renderForm();
});

// File upload fix

function addFieldError($fieldCont, key, jsErrors) {
  var input, id, describedBy, roleString;
  if ($fieldCont.length && $fieldCont.is(":visible")) {
    $fieldCont.addClass("frm_blank_field");
    input = $fieldCont.find("input, select, textarea");
    id = "frm_error_field_" + key;
    describedBy = input.attr("aria-describedby");

    if (typeof frmThemeOverride_frmPlaceError === "function") {
      // eslint-disable-line camelcase
      frmThemeOverride_frmPlaceError(key, jsErrors);
    } else {
      if (-1 !== jsErrors[key].indexOf("<div")) {
        $fieldCont.append(jsErrors[key]);
      } else {
        roleString = frm_js.include_alert_role ? 'role="alert"' : ""; // eslint-disable-line camelcase
        $fieldCont.append(
          '<div class="frm_error" ' +
            roleString +
            ' id="' +
            id +
            '">' +
            jsErrors[key] +
            "</div>"
        );
      }

      if (typeof describedBy === "undefined") {
        describedBy = id;
      } else if (
        describedBy.indexOf(id) === -1 &&
        describedBy.indexOf("frm_error_field_") === -1
      ) {
        if (input.data("error-first") === 0) {
          describedBy = describedBy + " " + id;
        } else {
          describedBy = id + " " + describedBy;
        }
      }

      input.attr("aria-describedby", describedBy);
    }
    input.attr("aria-invalid", true);

    jQuery(document).trigger("frmAddFieldError", [$fieldCont, key, jsErrors]);
  }
}

function removeAllErrors() {
  jQuery(".form-field").removeClass("frm_blank_field has-error");
  jQuery(".form-field .frm_error").replaceWith("");
  jQuery(".frm_error_style").remove();
}

jQuery("#maincontent").on("submit", ".frm_forms form", (e) => {
  e.target.prepend(loader());
  if (jQuery(e.target).find("input[type=file]") < 2) {
    return;
  }
  e.stopPropagation();
  e.preventDefault();
  jQuery("#maincontent :button").prop("disabled", true); // Disable all the buttons

  var data =
    jQuery(e.target).serialize() +
    "&has_file_upload=true" +
    "&action=frm_entries_create" +
    "&nonce=" +
    frm_js.nonce;

  jQuery.ajax({
    data: data,
    dataType: "json",
    type: "POST",
    url: frm_js.ajax_url,
    success: function (response) {
      if (Object.keys(response.errors).length > 1) {
        removeAllErrors();
        jQuery(e.target).prepend(response.error_message);
        for (let key in response.errors) {
          var $fieldCont = jQuery("#maincontent").find(
            "#frm_field_" + key + "_container"
          );
          if ($fieldCont) {
            addFieldError($fieldCont, key, response.errors);
            document.querySelector(".frm_error_style").scrollIntoView(true);
          }
        }
        jQuery("#maincontent :button").prop("disabled", false);
        document.getElementById("loader").remove();
        return;
      }
      e.target.submit();
    },
  });
});

if (window.history.replaceState) {
  window.history.replaceState(null, null, window.location.href);
}

